import Guid from "@/app/types/common/guid";

/**
 * Singleton class to manage a unique browser id.
 *
 * This id is used in logs to identify which browser instance generated the log,
 * which provides a fairly reliable way to identify a user, even if they aren't
 * logged in.
 *
 * It is also used to link a session to a browser instance.
 */
export class BrowserIdentityManager {
  private static _instance: BrowserIdentityManager;
  private _id = "";
  private readonly _localStorageKey = "bm-browser-id";

  private constructor() {}

  public static getInstance(): BrowserIdentityManager {
    if (!BrowserIdentityManager._instance) {
      BrowserIdentityManager._instance = new BrowserIdentityManager();
    }

    return BrowserIdentityManager._instance;
  }

  /**
   * Returns a unique browser identifier. If an id has not been generated yet,
   * one will be created and stored in `localStorage`.
   */
  getBrowserInstanceId(): string {
    if (this._id) {
      return this._id;
    }

    const idFromLocalStorage = localStorage.getItem(this._localStorageKey);

    if (idFromLocalStorage) {
      this._id = idFromLocalStorage;
      return this._id;
    }

    this._id = Guid.create().toString();
    localStorage.setItem(this._localStorageKey, this._id);

    return this._id;
  }
}
